<template>
  <div class="global form">
    <div class="searched-term">
      <h2 v-show="this.searched && this.term.length">{{ resultsTitle }}</h2>
    </div>
    <form v-on:submit.prevent>
      <div class="field">
        <input
          ref="input"
          v-model="query"
          aria-placeholder="Enter keyword(s)"
          placeholder="Enter keyword(s)"
          class="input"
          autocomplete="on"
          @keydown.enter="initSearch"
        />
        <div class="clear-input" @click="clearInput">
          <Icon :name="iconClose" />
        </div>
      </div>
      <SearchQuery
        class="button"
        :disabled="query.length === 0"
        :searchText="searchButtonText"
        :index="es.index"
        :from="es.from"
        :query="es.query"
        :size="esSize"
        :searched="searched"
        :term="query"
        :page="page"
        @click="initSearch"
        v-on:start:search="validateSearch"
      />
    </form>
    <div class="warning" v-if="bad.trigger">
      {{ this.bad.termWarningMessage }}
    </div>
    <!-- <b-message
      title="Warning"
      class="warning"
      v-if="bad.trigger"
      type="is-warning"
    >
      {{ this.bad.termWarningMessage }}
    </b-message> -->
  </div>
</template>

<script>
import SearchQuery from "@/components/SearchQuery";
import naughtyStrings from "@/assets/blns.json";

export default {
  name: "GlobalSearchForm",
  inject: ["runtimeConfig"],
  data() {
    return {
      bad: {
        term: naughtyStrings,
        termWarningMessage:
          "Sorry, this is a restricted query, please try again.",
        trigger: false
      },
      es: {
        currentPage: this.page,
        from: 0,
        index: this.runtimeConfig.elasticsearch.index,
        query: {},
        size: this.esSize
      },
      iconClose: "",
      query: "",
      searchButtonText: "Search Site",
      searched: false
    };
  },
  props: {
    esSize: {
      type: Number,
      default: 50
    },
    searching: Boolean,
    term: String,
    totals: Number,
    page: Number
  },
  components: {
    SearchQuery
  },
  computed: {
    resultsTitle() {
      return this.query.length || this.term.length
        ? `Search Results for '${this.term}'`
        : `Search Results`;
    }
  },
  watch: {
    esSize() {
      this.search();
    },
    page(newVal) {
      this.es.currentPage = newVal;
      this.es.from = this.es.size * newVal;
      this.pageUpdated();
    },
    searching() {
      this.setQuery();
    },
    term(val) {
      this.query = val;
      this.setQuery();
    },
    query(newVal) {
      this.iconClose = newVal.length ? "CloseBold" : "";
    }
  },
  mounted() {
    this.setSearch();
    this.validateSearch();
  },
  created() {
    window.addEventListener("keypress", e => {
      if (e.keyCode === 13) {
        this.validateSearch();
        this.searched = true;
      }
    });
  },
  destroyed() {
    window.removeEventListener("keypress", this.validateSearch);
  },
  methods: {
    checkQuery() {
      if (this.term === this.es.query) {
        // do nothing
      } else {
        this.es.currentPage = 1;
        this.$emit("update:page", { page: this.es.currentPage });
      }
    },
    clearInput() {
      this.query = "";
      this.$refs.input.focus();
    },
    initSearch() {
      this.searched = !this.searched && this.query.length;
    },
    pageUpdated() {
      this.$emit("update:page");
      if (this.es.currentPage < this.page) {
        this.nextPage();
      } else {
        this.prevPage();
      }
    },
    nextPage() {
      this.$emit(
        "next",
        ((this.es.currentPage += 1), (this.es.from += this.es.size))
      );
    },
    prevPage() {
      this.$emit(
        "prev",
        ((this.es.currentPage -= 1), (this.es.from -= this.es.size))
      );
    },
    setQuery() {
      this.es.query = {
        multi_match: {
          fields: [
            "description^1",
            "keywords^1",
            "content^.5",
            "title^3",
            "url^2.5"
          ],
          operator: "and",
          query: this.query,
          tie_breaker: "0.3",
          type: "best_fields",
          zero_terms_query: "all"
        }
      };
    },
    setSearch() {
      this.query = this.$route.query.qt || "";
      if (this.query.length) {
        this.searched = true;
      }
    },
    search() {
      if (this.bad.trigger === false) {
        this.checkQuery();
        this.setQuery();
        this.$emit("queried:terms", {
          term: this.query,
          page: this.es.currentPage
        });
      }
    },
    validateSearch() {
      this.bad.trigger = this.bad.term.includes(this.query);
      this.search();
    }
  }
};
</script>

<style lang="scss" scoped>
.global {
  &.form {
    background-color: #1a47b8;
    .searched-term {
      @include f-heading-5;
      @include container;
      color: $color__white;
      padding-bottom: $spacing-07;
      height: $spacing-11; //using 60px as height so it won't bounce when empty or when it shows
    }
    form {
      @include container;
      @include spacing($inner-spacing-02, "padding-bottom");
      display: flex;
      align-items: center !important;
      justify-content: center !important;
      .field {
        border-bottom: 1px solid $white;
        display: flex;
        margin-bottom: 0 !important;
        padding-bottom: $spacing-03;
        width: 100%;
        .control {
          border-bottom: 1px solid $white;
          padding-bottom: $spacing-03;
          width: 100%;
        }
        .input {
          @include f-ui-2;
          background: transparent;
          border: none;
          border-radius: 0;
          box-shadow: none;
          color: $white;
          padding: 0;
          width: 100%;
          &::placeholder {
            color: $white;
          }
          &:focus {
            outline: none;
          }
        }
        .clear-input {
          color: $white;
          padding-top: $spacing-02;
        }
      }
      .button {
        border: none;
        border-radius: 0;
        padding-bottom: $spacing-03;
        &:focus {
          outline: none;
        }
        &:disabled {
          color: $color__blue--30;
          cursor: default;
        }
      }
      @media screen and (max-width: 1023px) {
        .button {
          margin-bottom: $spacing-03 + 2;
        }
      }
      @media screen and (max-width: 767px) {
        .button {
          margin-bottom: $spacing-03;
        }
      }
      #search {
        align-self: flex-end;
        display: flex;
        background: transparent;
      }
      .break {
        flex-basis: 100%;
        height: 0;
      }
    }
  }
}
.warning {
  color: $color__white;
  text-align: center;
  @include spacing($inner-spacing-02, "padding-bottom");
}
</style>
